import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($) {
    const path = `/business/authorisations`
    let results = (await HTTP.get(path)).data
    return results
  },

  async get(actionId) {
    const path = `/business/authorisations/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/authorisations`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async authorize(authorisationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/authorisations/${authorisationId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(authorisationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/authorisations/${authorisationId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/business/authorisations/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/business/authorisations/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
